import type { ScheduledMeeting } from '../../../contexts';
import { PERSONAL_MEETING_DESCRIPTION_PREFIX } from './constants';

/**
 * Get badge label for a meeting
 * Returns 'DEFAULT MEETING ID' for default meetings, 'DRAFT' for meetings without description
 */
export const getMeetingBadgeLabel = (
  meeting: ScheduledMeeting,
  isDefault: boolean,
): string | null => {
  if (isDefault) {
    return 'DEFAULT MEETING ID';
  }
  if (!meeting.description) {
    return 'DRAFT';
  }
  return null;
};

/**
 * Get display title for a meeting
 * Falls back or 'Untitled meeting' if no description
 */
export const getMeetingDisplayTitle = (meeting: ScheduledMeeting): string => {
  return meeting.description || 'Untitled meeting';
};

export const filterPersonalMeetingsFromModal = (meeting: ScheduledMeeting): boolean => {
  const { description } = meeting;

  return !!description && description.startsWith(PERSONAL_MEETING_DESCRIPTION_PREFIX);
};

export const filterRestPersonalMeetings = (meeting: ScheduledMeeting): boolean => {
  const { description } = meeting;

  return !!description && !description.startsWith(PERSONAL_MEETING_DESCRIPTION_PREFIX);
};

export const filterDraftMeeting = (meeting: ScheduledMeeting): boolean => {
  const { description } = meeting;

  return !description;
};
